import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/AgenticAiBuilderEarlyAccessPage.head';
import { AgenticAiBuilderEarlyAccessPage } from '@pages/AgenticAiBuilderEarlyAccessPage';

export const Route = createFileRoute('/agentic-ai-builder-early-access')({
  component: AgenticAiBuilderEarlyAccessPage,
  head: () => head,
});
